import { render, staticRenderFns } from "./SendMailConfirmModal.vue?vue&type=template&id=d04e73d4&lang=pug"
import script from "./SendMailConfirmModal.vue?vue&type=script&lang=ts"
export * from "./SendMailConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports